export default __webpack_public_path__ + "static/media/library.6a54a4a4.svg";